export const REQUEST_STATUS_VIEW = {
  pendiente: {
    icon: "⏳",
    title: "Solicitud en proceso de validación",
    text: "Recibimos tu solicitud de domiciliario. Estamos validando tus datos y tu documento; te avisaremos cuando sea aprobada. No es necesario enviar otra.",
  },
  aprobado: {
    icon: "✅",
    title: "Ya eres domiciliario",
    text: "Tu cuenta de domiciliario está aprobada.",
  },
  rechazado: {
    icon: "❌",
    title: "Solicitud no aprobada",
    text: "Tu solicitud no fue aprobada.",
  },
};
